import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-attr-shape-10",
  "use": "icon-attr-shape-10-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-attr-shape-10\"><path d=\"M24.928 15.23 10.072 4.668C9.358 4.162 8.5 4.859 8.5 5.94v21.12c0 1.084.858 1.778 1.572 1.271l14.856-10.56c.763-.539.763-2 0-2.542z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol